export default __webpack_public_path__ + "d2b73dde6025351b334f4a2d6770f517.png";